<template>
  <div class="loginbody">
    <div class="bg-blur"></div>
    <!-- <div id="particles-js"> -->
    <div class="login-container" v-cloak>
      <el-card class="el_card_content_tilte">
        <div class="el_card_content_tilte_div">
          <p class="p_hi">Hi，您好！</p>
          <p class="p_center">欢迎登录富鑫科技管理平台</p>
          <p class="p_canit">设备管理 · 运营决策 · 数据分析</p>
        </div>
      </el-card>
      <el-card class="el_card_content_login">
        <div class="el_card_container">
          <div class="logo"></div>
          <el-form
            :model="loginForm"
            :rules="rules"
            ref="loginForm"
            @submit.native.prevent
          >
            <el-form-item prop="username">
              <el-input
                type="text"
                v-model="loginForm.username"
                placeholder="请输入账户名"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                native-type="submit"
                @click="submitForm('loginForm')"
                >登 录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import { AxiosAjax, saveToken, saveLoginData } from "../../js/axios.config";

export default {
  data() {
    return {
      imgSrc: null,
      loginForm: {
        username: "",
        password: "",
        codeKey: null,
        codeValue: null,
      },
      rules: {
        username: [
          { required: true, message: "请输入登录用户名", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        codeValue: [
          //{ required: true, message: '请输入验证码', trigger: 'blur' },
          //{ len: 4, message: '请输入 4 位的验证码', trigger: 'blur' }
        ],
      },
    };
  },
  mounted() {
    localStorage.clear();
  },

  methods: {
    initData: function () {
      let _this = this;
      AxiosAjax({
        url: "/verifycode",
        success: function (res) {
          _this.loginForm.codeKey = res.data.key;
          _this.imgSrc = res.data.data;
        },
      });
    },
    submitForm: function (formName) {
      let _this = this; //当前页面
      //表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          AxiosAjax({
            method: "post",
            url: "/cabinet/auth/login",
            data: _this.loginForm,
            loading: true,
            success: function (res) {
              console.log("code:", res.data.code);

              if (res.data.code == "000000") {
                //存储Token到本地
                if (!window.localStorage) {
                  _this.$message({
                    type: "error",
                    message: "浏览器不支持Storage，请升级",
                  });
                  return false;
                }

                saveToken(res.data.data.authorization, "");
                saveLoginData(res.data.data);
                // _this.powerPlant();

                if (_this.loginForm.password == "123456") {
                  localStorage.setItem("fx_login_simple", "simple");
                } else {
                  localStorage.setItem("fx_login_simple", "");
                }

                window.location.href = "/";
              } else {
              }
            },
          });
        } else {
          return false;
        }
      });
    },
    //切换验证码
    toggleCode() {
      //this.initData();
    },
  },
  created: function () {
    //初始化数据
    //this.initData();
  },
};
</script>
<style scoped>
.bg-blur {
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  opacity: 0.4;
}

.loginbody {
  /* background-image:url(../../assets/index.jpg) ; */
  background-image: url(../../assets/bg_login.png);
  background-size: cover;
  /* text-align: center; */
  height: 100vh;
}

.el-form-item {
  margin-bottom: 40px;
}

.login-container {
  /* height: 420px;
    min-width: 1000px;
    position: absolute;
    margin: -250px auto auto -500px;
    left: 50%;
    top: 50%;
    display: flex;
    -moz-opacity: 0.9;
    opacity: 0.9; */

  position: absolute;
  top: 50%;
  left: 50%;
  width: 1226px;
  display: flex;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-box-shadow: 0 29px 29px -29px rgba(0, 0, 0, 0.6);
  box-shadow: 0 29px 29px -29px rgba(0, 0, 0, 0.6);
}

.el_card_content_tilte {
  position: relative;
  font-weight: 400;
  width: 710px;
  height: 510px;
  color: #fff;
  border: 0;
  background: linear-gradient(
    176deg,
    rgba(243, 244, 252, 0.65),
    rgba(64, 158, 255, 0.95)
  );
  border-radius: 4px 0 0 4px;
  font-family: PingFangSC, PingFangSC-Regular;
}

.el_card_content_tilte .el_card_content_tilte_div {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 9;
  padding: 155px 0 176px 70px;
  color: #fff;
}

.el_card_content_tilte .el_card_content_tilte_div p {
  text-align: left;
}

.p_hi {
  font-size: 38px;
  font-weight: 200;
}

.p_center {
  font-size: 40px;
  margin: 22px 0 24px;
  font-weight: 200;
}

.p_canit {
  font-size: 22px;
  font-weight: 200;
}

.el_card_content_login {
  width: 516px;
  height: 510px;
  border: 0;
  background: #fff;
  border-radius: 0 4px 4px 0;
}

.el_card_container {
  padding-left: 40px;
  padding-right: 40px;
}

.login-container /deep/ .el-input--prefix .el-input__inner {
  height: 50px;
  line-height: 50px;
}

.login-container .el-button {
  height: 50px;
  font-size: 21px;
  display: block;
  width: 100%;
}

.login-container .logo {
  margin-bottom: 40px;
  height: 90px;
  background: url(../../assets/logo.png) no-repeat center;
}

.login-container .code {
  width: 80px;
  height: 30px;
  vertical-align: middle;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue